var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMessage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 37,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  y: 0.987,
  fill: "#121218",
  rx: 18
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#message_svg__a)",
  d: "M26 14.987c1.094 0 2 .906 2 2v6.031c0 1.094-.906 1.97-2 1.97h-1v1.624c0 .25-.188.375-.375.375-.094 0-.156 0-.25-.062L21 24.987h-3.031c-1.094 0-1.969-.875-1.969-2v-1h1v1c0 .563.438 1 1 1h3.25L24 25.55v-1.563h2c.531 0 1-.437 1-1v-6c0-.531-.469-1-1-1h-4v-1h4Zm-5 4c0 1.125-.906 2-2 2h-4l-3.406 1.938c-.094.062-.156.062-.219.062-.219 0-.375-.125-.375-.375v-1.594l-1-.03c-1.125 0-2-.876-2-2v-6c0-1.095.875-2 2-2h9c1.094 0 2 .905 2 2v6Zm-6.281 1H19c.531 0 1-.437 1-1v-6c0-.531-.469-1-1-1h-9c-.563 0-1 .469-1 1v6c0 .563.438 1 1 1h2v1.563l2.719-1.563Z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "message_svg__a",
  x1: 18,
  x2: 18,
  y1: 0.987,
  y2: 40.684,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B55CFD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5548F3"
})))));
export { SvgMessage as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZmMwZDZlNmRkOWZmNTZhNDkzMjdiNWViYjk4NzNlZjkuc3ZnIjs=";